{
	"title": "Transacciones en conciliación",
	"filterByLabel": "Filtrar por",
	"filterByPlaceholder": "Seleccionar filtro",
	"filterOptions": {
		"paymentMethod": "Método de Pago",
		"paymentMethodCredit": "Crédito",
		"paymentMethodDebit": "Débito",
		"vendor": "Vendor",
		"status": "Estado"
	},
	"searchPlaceholder": "Buscar por...",
	"columns": {
		"transactionDate": "FECHA DE LA TRANSACCIÓN",
		"paymentMethod": "MÉTODO DE PAGO",
		"vendor": "VENDOR",
		"terminalNumber": "N.° DEL TERMINAL",
		"status": "ESTADO",
		"value": "VALOR",
		"receipt": "COMPROBANTE"
	},
	"statusPending": "PENDIENTE",
	"statusProcessed": "PROCESADA",
	"statusReconciled": "CONCILIADA",
	"statusCancelled": "CANCELADA",
	"statusTooltipPaid": "Transacción ya pagada al adquirente",
	"receiptTooltipView": "Ver comprobante",
	"receiptTooltipUnavailable": "Comprobante no disponible",
	"of": "de",
	"backButton": "Volver"
}
